import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"

import { H3, YekanParagraph } from "../typography"
import { FeatureCTA, Container } from "./styled"
import { Button } from "../inputs"
import { colors } from "../../utils/styleVariables"

const MoreFeatures = () => {
  const data = useStaticQuery(graphql`
    {
      yaml: contentYaml(header: { slug: { eq: "/index" } }) {
        content {
          adminFeatures {
            cta {
              title
              description
              button
              to
            }
          }
        }
      }
    }
  `)
  const { title, description, button, to } = data.yaml.content.adminFeatures.cta

  return (
    <Link to={to} style={{ textDecoration: "none" }}>
      <Container halign="center">
        <FeatureCTA direction="vertical">
          <H3>{title}</H3>
          <YekanParagraph>{description}</YekanParagraph>
          <Button
            text={button}
            name={button}
            shadowColor={colors.coralShadow}
            backgroundColor={[...colors.coral, "0.3"]}
            color={colors.coral}
            handleClick={() => () => null}
          />
        </FeatureCTA>
      </Container>
    </Link>
  )
}

export default MoreFeatures
